// Check if current environment is Nexos
const isNexos = () => process.env.VUE_APP_CUSTOMER === 'nexos';

// Format path with Nexos prefix if needed
const formatPath = (path) => {
  if (!path) return path;
  return isNexos() && !path.startsWith('/nexos') 
    ? `/nexos${path.startsWith('/') ? '' : '/'}${path}`
    : path;
};

/**
 * Track events in dataLayer for analytics
 * @param {Object} options - The event options
 * @param {string} options.eventType - The type of event (e.g., 'PAGEVIEW', 'MENU', 'BUTTON', 'LINK')
 * @param {string} options.nombreFlujo - The flow name (e.g., 'login', 'home')
 * @param {string} [options.seccion='nexos'] - The section name
 * @param {string} [options.activo='bancolombia'] - The active entity
 * @param {string} [options.path] - The page path (for pageview events)
 * @param {string} [options.menu] - The menu name (for menu events)
 * @param {string} [options.elemento] - The element that was interacted with
 * @param {string} [options.ubicacion] - The location of the element (e.g., 'header', 'footer')
 */
export function trackDataLayerEvent({
  eventType,
  nombreFlujo,
  seccion = 'nexos',
  activo = 'bancolombia',
  path,
  menu,
  elemento,
  ubicacion,
  modal,
}) {
  if (typeof window === 'undefined' || !window.dataLayer || !isNexos()) return;

  const eventMap = {
    PAGEVIEW: 'SEND_PAGEVIEW_BANCOLOMBIA',
    MENU: 'SEND_MENU_BANCOLOMBIA',
    BUTTON: 'SEND_BOTONES_BANCOLOMBIA',
    LINK: 'SEND_LINKS_BANCOLOMBIA',
    CARD: 'SEND_CARDS_BANCOLOMBIA',
    MODALVIEW: 'SEND_PAGEVIEW_MODAL_BANCOLOMBIA',
  };

  const baseEvent = {
    event: eventMap[eventType] || eventType,
    activo,
    nombreFlujo,
    seccion,
  };

  // Add optional properties if they exist
  if (path) baseEvent.path = formatPath(path);
  if (menu) baseEvent.menu = menu;
  if (elemento) baseEvent.elemento = elemento;
  if (ubicacion) baseEvent.ubicacion = ubicacion;
  if (modal) baseEvent.modal = modal;

  console.log('trackDataLayerEvent', baseEvent);

  window.dataLayer.push(baseEvent);
}

// Helper functions for common event types
export const trackPageview = (nombreFlujo, path) => {
  trackDataLayerEvent({
    eventType: 'PAGEVIEW',
    nombreFlujo,
    path: formatPath(path),
  });
};
export const trackModalPageview = (nombreFlujo, modal, path) => {
  trackDataLayerEvent({
    eventType: 'MODALVIEW',
    nombreFlujo,
    modal,
    path: formatPath(path),
  });
};

export const trackMenuClick = (nombreFlujo, menu, elemento, ubicacion) => {
  trackDataLayerEvent({
    eventType: 'MENU',
    nombreFlujo,
    menu,
    elemento,
    ubicacion,
  });
};

export const trackButtonClick = (nombreFlujo, elemento, ubicacion, modal) => {
  trackDataLayerEvent({
    eventType: 'BUTTON',
    nombreFlujo,
    elemento,
    ubicacion,
    modal,
  });
};

export const trackLinkClick = (nombreFlujo, elemento, ubicacion) => {
  trackDataLayerEvent({
    eventType: 'LINK',
    nombreFlujo,
    elemento,
    ubicacion,
  });
};

export const trackCardClick = (nombreFlujo, elemento, ubicacion) => {
  trackDataLayerEvent({
    eventType: 'CARD',
    nombreFlujo,
    elemento,
    ubicacion,
  });
};